import DesktopAlertBanner from './alertBanner/DesktopAlertBanner';
import MobileAlertBanner from './alertBanner/MobileAlertBanner';
import useFormat from '../../hooks/useFormat';
import { AlertBannerProps } from '../types/alert';

const sanitizeOptions = {
	allowedTags: ['b', 'strong', 'i', 'em', 'mark', 'small', 'del', 'ins', 'sub', 'sup', 'p', 'span', 'a', 'br'],
	allowedAttributes: {
		a: ['href', 'name', 'target'],
		'*': ['style'],
	},
};

const AlertBanner = ({ content }: Pick<AlertBannerProps, 'content'>) => {
	const { isMobileFormat } = useFormat();

	return isMobileFormat ? (
		<MobileAlertBanner content={content} sanitizeOptions={sanitizeOptions} />
	) : (
		<DesktopAlertBanner content={content} sanitizeOptions={sanitizeOptions} />
	);
};

export default AlertBanner;
